"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesSelector = PropertiesSelector;
const uom_1 = require("uom");
const property_1 = require("@promaster-sdk/property");
const PropertyFiltering = __importStar(require("@promaster-sdk/property-filter-pretty"));
const default_layout_renderer_1 = require("./default-layout-renderer");
const default_group_component_1 = require("./default-group-component");
const default_group_item_component_1 = require("./default-group-item-component");
const default_property_label_component_1 = require("./default-property-label-component");
const default_property_selector_component_1 = require("./default-property-selector-component");
function PropertiesSelector(props) {
    // Do destructoring and set defaults
    const { productProperties, selectedProperties, filterPrettyPrint = (propertyFilter) => PropertyFiltering.filterPrettyPrintIndented(
    // PropertyFiltering.FilterPrettyPrintMessagesEnglish,
    PropertyFiltering.buildEnglishMessages(props.unitsFormat), 2, " ", propertyFilter, props.unitsFormat, props.unitLookup), includeCodes = false, includeHiddenProperties = false, autoSelectSingleValidValue = true, lockSingleValidValue = false, onChange = (_a, _propertyName
    // biome-ignore lint: -
    ) => { }, onPropertyFormatChanged = (_a, _b, _c
    // biome-ignore lint: -
    ) => { }, 
    // biome-ignore lint: -
    onPropertyFormatCleared = (_a) => { }, 
    // biome-ignore lint: -
    onPropertyFormatSelectorToggled = () => { }, translatePropertyName = (a) => a, translatePropertyValue = (a, b) => `${a}_${b}`, translateValueMustBeNumericMessage = () => "value_must_be_numeric", translateValueIsRequiredMessage = () => "value_is_required", translatePropertyLabelHover = () => "translatePropertyLabelHover", translateGroupName = (a) => a, readOnlyProperties = [], optionalProperties = [], propertyFormats = {}, inputDebounceTime = 350, unitsFormat, units, closedGroups = [], 
    // biome-ignore lint: -
    onToggleGroupClosed = () => { }, LayoutRenderer = default_layout_renderer_1.DefaultLayoutRenderer, GroupComponent = default_group_component_1.DefaultGroupComponent, GroupItemComponent = default_group_item_component_1.DefaultGroupItemComponent, PropertySelectorComponent = (0, default_property_selector_component_1.createPropertySelector)({}), PropertyLabelComponent = default_property_label_component_1.DefaultPropertyLabelComponent, comparer = property_1.PropertyValue.defaultComparer } = props;
    const selectors = createPropertySelectorRenderInfos(productProperties, selectedProperties, filterPrettyPrint, includeCodes, includeHiddenProperties, autoSelectSingleValidValue, lockSingleValidValue, onChange, onPropertyFormatChanged, onPropertyFormatCleared, onPropertyFormatSelectorToggled, translatePropertyName, translatePropertyValue, translateValueMustBeNumericMessage, translateValueIsRequiredMessage, translatePropertyLabelHover, readOnlyProperties, optionalProperties, propertyFormats, inputDebounceTime, unitsFormat, units, comparer);
    return LayoutRenderer({
        selectors: selectors,
        translateGroupName: translateGroupName,
        closedGroups: closedGroups,
        onToggleGroupClosed: onToggleGroupClosed,
        GroupComponent: GroupComponent,
        GroupItemComponent: GroupItemComponent,
        PropertySelectorComponent: PropertySelectorComponent,
        PropertyLabelComponent: PropertyLabelComponent
    });
}
function createPropertySelectorRenderInfos(productProperties, selectedProperties, filterPrettyPrint, includeCodes, includeHiddenProperties, autoSelectSingleValidValue, lockSingleValidValue, onChange, onPropertyFormatChanged, onPropertyFormatCleared, onPropertyFormatSelectorToggled, translatePropertyName, translatePropertyValue, translateValueMustBeNumericMessage, translateValueIsRequiredMessage, translatePropertyLabelHover, readOnlyProperties, optionalProperties, propertyFormats, inputDebounceTime, unitsFormat, 
// units: {
//   readonly [key: string]: Unit.Unit;
// },
units, comparer) {
    // Default true if not specified otherwise
    autoSelectSingleValidValue =
        autoSelectSingleValidValue === null ||
            autoSelectSingleValidValue === undefined
            ? true
            : autoSelectSingleValidValue;
    // const sortedArray = R.sortBy((p) => p.sortNo, productProperties);
    const sortedArray = productProperties
        .slice()
        .sort((a, b) => a.sort_no < b.sort_no ? -1 : a.sort_no > b.sort_no ? 1 : 0);
    const selectorDefinitions = sortedArray
        .filter((property) => includeHiddenProperties ||
        property_1.PropertyFilter.isValid(selectedProperties, property.visibility_filter, comparer))
        .map((property) => {
        const selectedValue = property_1.PropertyValueSet.getValue(property.name, selectedProperties);
        const selectedValueItem = property.value &&
            property.value.find((value) => (value.value === undefined && selectedValue === undefined) ||
                (value.value &&
                    property_1.PropertyValue.equals(selectedValue, value.value, comparer)));
        let isValid;
        let defaultFormat = { unit: uom_1.Unit.One, decimalCount: 2 };
        switch (getPropertyType(property.quantity)) {
            case "integer":
                isValid = selectedValueItem
                    ? property_1.PropertyFilter.isValid(selectedProperties, selectedValueItem.property_filter, comparer)
                    : false;
                break;
            case "amount":
                defaultFormat =
                    selectedValue && selectedValue.type === "amount"
                        ? {
                            unit: selectedValue.value.unit,
                            decimalCount: selectedValue.value.decimalCount
                        }
                        : defaultFormat;
                isValid =
                    property.validation_filter &&
                        property_1.PropertyFilter.isValid(selectedProperties, property.validation_filter, comparer);
                break;
            default:
                isValid = true;
        }
        const isReadOnly = readOnlyProperties.indexOf(property.name) !== -1;
        // TODO: Better handling of format to use when the format is missing in the map
        const propertyFormat = propertyFormats[property.name] || defaultFormat;
        const isHidden = !property_1.PropertyFilter.isValid(selectedProperties, property.visibility_filter, comparer);
        const label = translatePropertyName(property.name) +
            (includeCodes ? " (" + property.name + ")" : "");
        const labelHover = translatePropertyLabelHover(property.name);
        const selectorType = getSelectorType(property);
        const propertySelectorComponentProps = {
            selectorType: selectorType,
            propertyName: property.name,
            quantity: property.quantity,
            validationFilter: property.validation_filter,
            valueItems: property.value,
            selectedProperties,
            includeCodes,
            optionalProperties,
            onChange: handleChange(onChange, productProperties, autoSelectSingleValidValue, comparer),
            onPropertyFormatChanged,
            onPropertyFormatCleared,
            onPropertyFormatSelectorToggled,
            filterPrettyPrint,
            propertyFormat,
            readOnly: isReadOnly,
            locked: autoSelectSingleValidValue || lockSingleValidValue
                ? shouldBeLocked(selectedValueItem, property, selectedProperties, comparer)
                : false,
            translatePropertyValue,
            translateValueMustBeNumericMessage: translateValueMustBeNumericMessage,
            translateValueIsRequiredMessage,
            inputDebounceTime,
            unitsFormat,
            units
        };
        const propertyLabelComponentProps = {
            propertyName: property.name,
            selectorIsValid: isValid,
            selectorIsHidden: isHidden,
            selectorLabel: label,
            translatePropertyLabelHover
        };
        return {
            sortNo: property.sort_no,
            propertyName: property.name,
            groupName: property.group,
            isValid: isValid,
            isHidden: isHidden,
            label: label,
            labelHover: labelHover,
            selectorComponentProps: propertySelectorComponentProps,
            labelComponentProps: propertyLabelComponentProps
        };
    });
    return selectorDefinitions;
}
function getSelectorType(property) {
    if (property.quantity === "Text") {
        return "TextBox";
    }
    else if (property.quantity === "Discrete") {
        if (property.selector_type === "RadioGroup") {
            return "RadioGroup";
        }
        else if (property.selector_type === "Checkbox") {
            return "Checkbox";
        }
        else {
            return "ComboBox";
        }
    }
    else {
        return "AmountField";
    }
}
function getPropertyType(quantity) {
    switch (quantity) {
        case "Text":
            return "text";
        case "Discrete":
            return "integer";
        default:
            return "amount";
    }
}
function getSingleValidValueOrUndefined(productProperty, properties, comparer) {
    if (productProperty.quantity === "Discrete") {
        const validPropertyValueItems = [];
        for (const productValueItem of productProperty.value) {
            const isValid = property_1.PropertyFilter.isValid(properties, productValueItem.property_filter, comparer);
            if (isValid) {
                validPropertyValueItems.push(productValueItem);
            }
        }
        return validPropertyValueItems.length === 1
            ? validPropertyValueItems[0]
            : undefined;
    }
    return undefined;
}
function shouldBeLocked(selectedValueItem, productProperty, properties, comparer) {
    const singleValidValue = getSingleValidValueOrUndefined(productProperty, properties, comparer);
    // getSingleValidValueOrUndefined only works on onChange.
    // Prevent locking when the sent in selectedValue isn't the singleValidValue
    if (singleValidValue && singleValidValue === selectedValueItem) {
        return true;
    }
    return false;
}
function handleChange(externalOnChange, productProperties, autoSelectSingleValidValue, comparer) {
    return (properties, propertyName) => {
        if (!autoSelectSingleValidValue) {
            externalOnChange(properties, [propertyName]);
            return;
        }
        let lastProperties = properties;
        const changedProps = new Set([propertyName]);
        for (let i = 0; i < 4; i++) {
            for (const productProperty of productProperties) {
                if (productProperty.name === propertyName) {
                    continue;
                }
                const propertyValueItem = getSingleValidValueOrUndefined(productProperty, properties, comparer);
                if (propertyValueItem) {
                    properties = property_1.PropertyValueSet.set(productProperty.name, propertyValueItem.value, properties);
                    changedProps.add(productProperty.name);
                }
            }
            if (properties === lastProperties) {
                break;
            }
            lastProperties = properties;
        }
        externalOnChange(properties, Array.from(changedProps.keys()));
    };
}
//# sourceMappingURL=properties-selector.js.map